// extracted by mini-css-extract-plugin
module.exports = {"LeftMenu":"LeftMenu_LeftMenu__17-9E","active":"LeftMenu_active__2JrFS","option":"LeftMenu_option__26eCl"};